import { Grid } from '@mui/material';

import { FHButton } from '../../../../components/base';
import { FSelect } from '../../../../components/baseV2';
import { SCHEDULE_ACTIVITY_OPTIONS, SCHEDULE_DAY_OPTIONS } from '../constants';
import { SCHEDULE_ACTIVITY_SELECT_MENU_SX } from '../styles';
import ScheduleActivitySelectValue from './ScheduleActivitySelectValue';

import type { ScheduleSlotFieldsProps } from './types';

export default function ScheduleSlotFields({
  disabled,
  isSaving,
  dayOfWeek,
  activityType,
  startHour,
  endHour,
  startTimeOptions,
  endTimeOptions,
  canAdd,
  onDayChange,
  onActivityChange,
  onStartTimeChange,
  onEndTimeChange,
  onAdd,
}: ScheduleSlotFieldsProps) {
  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={12} sm={6} md={3}>
        <FSelect
          label="Day of week"
          fullWidth
          displayEmpty
          disabled={disabled}
          options={SCHEDULE_DAY_OPTIONS}
          value={dayOfWeek}
          renderValue={(value) =>
            SCHEDULE_DAY_OPTIONS.find((option) => option.value === value)?.label ?? 'Select day'
          }
          onUpdate={onDayChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FSelect
          label="Activity"
          fullWidth
          displayEmpty
          disabled={disabled}
          options={SCHEDULE_ACTIVITY_OPTIONS}
          value={activityType}
          menuProps={SCHEDULE_ACTIVITY_SELECT_MENU_SX}
          renderValue={(value) => (
            <ScheduleActivitySelectValue value={typeof value === 'string' ? value : ''} />
          )}
          onUpdate={onActivityChange}
        />
      </Grid>
      <Grid item xs={6} sm={3} md={2}>
        <FSelect
          label="Start time"
          fullWidth
          displayEmpty
          disabled={disabled}
          options={startTimeOptions}
          value={startHour}
          renderValue={(value) =>
            startTimeOptions.find((option) => option.value === value)?.label ?? 'Select time'
          }
          onUpdate={onStartTimeChange}
        />
      </Grid>
      <Grid item xs={6} sm={3} md={2}>
        <FSelect
          label="End time"
          fullWidth
          displayEmpty
          disabled={disabled}
          options={endTimeOptions}
          value={endHour}
          renderValue={(value) =>
            endTimeOptions.find((option) => option.value === value)?.label ?? 'Select time'
          }
          onUpdate={onEndTimeChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FHButton fullWidth loading={isSaving} disabled={!canAdd || disabled} onClick={onAdd}>
          Add time slot
        </FHButton>
      </Grid>
    </Grid>
  );
}
